import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { EmblaSlider } from '../theme/embla-slider'

export class MulticolumCarousel extends UcoastEl {
    static htmlSelector = 'multicolum-carousel'
    slider: EmblaSlider
    items: NodeListOf<HTMLLIElement>
    button: HTMLLinkElement
    constructor() {
        super()
        this.slider = q.rs('embla-slider', this)
        this.items = q.rl('.multicolum-carousel__info-item', this)
        this.button = q.rs('a.button', this)

        this.items.forEach(item => {
            item.addEventListener('mouseover', this.onMouseOver.bind(this))
            item.addEventListener('click', this.onMouseClick.bind(this))
            item.addEventListener('focus', this.onMouseOver.bind(this))
            item.addEventListener('keyup', this.onKeyUp.bind(this))
        })

        setTimeout(() => {
            this.slider.emblaApi?.on('select', this.onChangeSlider.bind(this))
        }, 500)
    }

    onChangeItem(currentItem: HTMLLIElement) {
        if(!currentItem) return
        this.button.setAttribute('href', currentItem.getAttribute('href')? currentItem.getAttribute('href').trim() : '#')
        this.items.forEach((item, index) => {
            item.classList.toggle('active', item == currentItem)
            if(item == currentItem && this.slider) {
                this.slider.scrollMove(index)
            }
        })
    }

    onMouseOver(event: Event) {
        event.preventDefault()
        const currentItem = q.rClosestTarget(event, '.multicolum-carousel__info-item') as HTMLLIElement
        this.onChangeItem(currentItem)
    }

    onMouseClick(event: Event) {
        event.preventDefault()
        const currentItem = q.rClosestTarget(event, '.multicolum-carousel__info-item') as HTMLLIElement
        if(window.innerWidth >= 768) {
            window.location.href = currentItem.getAttribute('href');
        }
        else this.onChangeItem(currentItem)
    }

    onKeyUp(event: KeyboardEvent) {
        event.preventDefault()
        if (event.code?.toUpperCase() !== 'ENTER') return
        const currentItem = q.rClosestTarget(event, '.multicolum-carousel__info-item') as HTMLLIElement
        if(window.innerWidth >= 768) {
            window.location.href = currentItem.getAttribute('href');
        }
        else this.onChangeItem(currentItem)
    }

    onChangeSlider() {
        const sliderIndex = this.slider.getSelectedIndex()
        const currentItem = this.items[sliderIndex]
        this.button.setAttribute('href', currentItem.getAttribute('href')? currentItem.getAttribute('href').trim() : '#')
        this.items.forEach((item, index) => {
            item.classList.toggle('active', index == sliderIndex)
        })
    }
}
